import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import configureStore from '../../untidy/redux/configure-store';
import { getInitialState } from '../../untidy/redux/reducers';

const sagaMiddleware = createSagaMiddleware({
  onError: (error: Error) => {
    console.error('Unhandled saga error', error);
  },
});
const store = configureStore(getInitialState(), sagaMiddleware);

interface Props {
  children: ReactNode;
}

export function ReduxProvider(props: Props) {
  return <Provider store={store}>{props.children}</Provider>;
}
